import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import TablePagination from 'components/shared/table/table-pagination'
import SortIcon from 'components/shared/icons/sort'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import ColStatus from '../col-status'

const PassportList = ({ selectedVenue, headers, list, sort, limit, page, total, fetchPassportBookings, pagePassport, sortPassport, confirmBooking }) => {
  useEffect(() => { fetchPassportBookings({ selectedVenue }) }, [selectedVenue, limit, page, sort])

  const DisplayDetails = item => {
    const { bookingDate, client, email, phone } = item

    return (
      <ul className="my-3 text-sm">
        <li>{`Booking Date: ${bookingDate}`}</li>
        <li>{`Client Name: ${client}`}</li>
        <li>{`Email: ${email}`}</li>
        <li>{`Phone: ${phone}`}</li>
      </ul>
    )
  }

  return (
    <div className="merchant-passport-list">
      <div className="overflow-auto mt-5">
        <Table classes="w-full border-collapse">
          <THead classes="text-xs bg-lightgray font-semibold">
            {headers.map((header, key) => {
              let sortIcon = <SortIcon />
              let nextOrder = 'desc'

              if (sort.field === header.field) {
                if (sort.order === 'desc') {
                  sortIcon = <SortedDown />
                  nextOrder = 'asc'
                } else {
                  sortIcon = <SortedUp />
                }
              }

              return (
              <TCol
                classes="p-3 text-primary-black"
                key={key}
                align={header.align || 'left'}
                onClick={() => header.sortable && sortPassport({ field: header.field, order: nextOrder })}
              >
                <div
                  className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                >
                  {header.name} {header.sortable && sortIcon}
                </div>
              </TCol>
            )
          })}
            </THead>
          <TBody>
            {list.map(item => (
              <TRow classes="border-t text-sm hover:bg-gray-100"
                key={item.id} PassedComponent={() => DisplayDetails(item.details)}>
                <TCol classes="p-3">{item.createDate}</TCol>
                <TCol classes="p-3">{item.bookingDate}</TCol>
                <TCol classes="p-3">{item.client}</TCol>
                <TCol classes="p-3 text-primary-orange">
                  <a href={item.spaceLink}>{item.space}</a>
                </TCol>
                <TCol classes="p-3">{item.noOfGuests}</TCol>
                <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                <TCol classes="p-3" align="right">
                  <ul className="flex items-center font-semibold flex-row justify-end text-center text-primary-orange">
                    {item.status === 'booked' && <li className="cursor-pointer" onClick={() => confirmBooking({ id: item.id })}>Confirm Booking</li>}
                  </ul>
                </TCol>
              </TRow>
            ))}
          </TBody>
        </Table>
      </div>
      <TablePagination
        currentPage={page}
        onPageChange={(newPage) => pagePassport({ page: newPage })}
        onPageSizeChange={(newPageSize) => pagePassport({ limit: newPageSize })}
        pageSize={limit}
        totalCount={total}
        className="mt-5"
      />
    </div>
  )
}

PassportList.propTypes = {
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headers: PropTypes.array.isRequired,
  fetchPassportBookings: PropTypes.func.isRequired,
  confirmBooking: PropTypes.func.isRequired,
  list: PropTypes.array,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pagePassport: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
  sortPassport: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.passport.headers,
  list: bookings.merchant.passport.list,
  page: bookings.merchant.passport.page,
  limit: bookings.merchant.passport.limit,
  total: bookings.merchant.passport.total,
  sort: bookings.merchant.passport.sort,
})

const mapDispatchToProps = {
  fetchPassportBookings: bookingActions.fetchMerchantPassportBookings,
  pagePassport: bookingActions.pageMerchantPassportBooking,
  confirmBooking: bookingActions.merchantConfirmPassportBooking,
  sortPassport: bookingActions.sortMerchantPassportBooking,
}

export default connect(mapStateToProps, mapDispatchToProps)(PassportList)
